module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_5.966be3e0.png";